import { c as _c } from "react/compiler-runtime";
import SearchNoResult from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/assets/search-no-result.png";
import { FC } from "react";
const noResultTitle = "نتیجه ای یافت نشد.";
const noResultFirstPart = " نتیجه ای برای";
const noResultSecondPart = " پیدا نکردیم.";
const noResultSearchAnotherWord = "با کلمه ی دیگری جستجو کنید.";
export const NoResult: FC<{
  query: string;
}> = properties => {
  const $ = _c(7);
  const {
    query
  } = properties;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <img alt="no result" className="w-[188px]" src={(SearchNoResult as unknown as {
      src: string;
    }).src} />;
    t1 = <div className="text-subtitle-1 text-on-surface-high-emphasis mt-6">{noResultTitle}</div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const t2 = `"${query}"`;
  let t3;
  if ($[2] !== t2) {
    t3 = <div className="text-caption text-on-surface-medium-emphasis mt-2 px-6 text-center">{noResultFirstPart}<span className="text-caption text-on-surface-high-emphasis font-medium">{t2}</span>{noResultSecondPart}</div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="text-caption text-on-surface-medium-emphasis mt-2 px-6 text-center">{noResultSearchAnotherWord}</div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className="my-6 flex flex-col items-center">{t0}{t1}{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};